import { useTranslation as useTranslationi18next } from 'react-i18next';
export const useTranslation = useTranslationi18next;
